import { render } from "./header.vue?vue&type=template&id=b4807432&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=b4807432&lang=scss&scoped=true"

import exportComponent from "D:\\project\\dongmeng\\meeting-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4807432"]])

export default __exports__